module.exports = __webpack_public_path__ + "static/img/health2.1323f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/championscity/challenge/health2.png
// module id = ldrQ
// module chunks = 1